module.exports = __webpack_public_path__ + "static/home-d2e4be073f1fcdd2b73f11ef7a8437d5.mp4";